module.exports = {"classes":["legal-page","header-dark"],"title":"Legal","metas":{"description":"Legal Information Prior Forms."},"opengraph":{"og:title":"Legal Prior Forms","og:description":"Legal Information Prior Forms.","og:url":"https://auth0.com/legal/prior-forms"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/prior-forms/metadata.json
// module id = 1535
// module chunks = 0